exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".api_logs {\n  display: flex;\n  position: relative;\n}\n.api_logs .logs {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 250px;\n  overflow-y: scroll;\n}\n.api_logs .log-wrapper {\n  margin-left: 250px;\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow: hidden;\n  min-height: 600px;\n}", ""]);

// exports
